<div class="div-action-top">
  <div class="form-filter ant-form ant-form-inline">
    <form nz-form [nzLayout]="'inline'" [formGroup]="form" class="form-filter" (ngSubmit)="doSearchPay()">
      <nz-form-item class="spacepad">
        <nz-form-control>
          <input style="width: 180px;" formControlName="specimenID" nz-input placeholder="Mã mẫu"/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-select nzAllowClear formControlName="partnerId" nzShowSearch nzPlaceHolder="Cộng tác viên">
            <nz-option *ngFor="let item of partners" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-select nzAllowClear formControlName="userTakenName" nzShowSearch nzPlaceHolder="NVLM">
            <nz-option *ngFor="let item of allUser" [nzValue]="item.username" [nzLabel]="item.fullname"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-date-picker style="width: 100%" formControlName="fromDate" nzPlaceHolder="Từ ngày..."
                          nzFormat="dd/MM/yyyy"
                          nz-input placeholder="Từ ngày">
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-date-picker style="width: 100%" formControlName="toDate" nzPlaceHolder="Đến ngày..." nzFormat="dd/MM/yyyy"
                          nz-input placeholder="Đến ngày">
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <button style="margin-right: 10px" nz-button nzType="primary" nzSize="default">Tìm kiếm</button>
          <button style="margin-right: 10px" nz-button nzType="dashed" nzSize="default" (click)="clearSearch()">Bỏ lọc
          </button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
</div>


<div nz-row class="row1">
  <div nz-col [nzSpan]="12">
    <div class="text-title">Chưa thanh toán
      <button class="btn-right btn-green" (click)="exportNeedData()" nz-button nzType="primary" nzSize="small">
        <span class="fa fa-file-excel fa-fw"></span>
        Xuất dữ liệu
      </button>
      <button [disabled]="!selectedBills.length" class="btn-right btn-primary mr-2" (click)="createBilling()" nz-button
              nzType="primary" nzSize="small">
        <span class="fa fa-money-bill fa-fw"></span>
        Nộp tiền
      </button>
    </div>

    <dx-data-grid #gridNeed
                  (onExporting)="onGridNeedPaidExporting($event)"
                  [height]="grid1Height"
                  [dataSource]="filterDataToPay"
                  [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true" [showColumnLines]="true"
                  [showRowLines]="true"
                  [selectedRowKeys]="[]"
                  (onSelectionChanged)="onNeedSelectionChanged($event)"
    >
      <dxi-column [fixed]="true"
                  caption="STT"
                  [width]="55"
                  [allowFiltering]="false"
                  [allowSorting]="false"
                  cssClass="text-center"
                  dataField="stt"
      ></dxi-column>

      <dxo-filter-row [visible]="true" [applyFilter]="currentFilter"></dxo-filter-row>
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-selection
        [selectAllMode]="'allPages'"
        [showCheckBoxesMode]="'always'"
        mode="multiple"
      ></dxo-selection>
      <dxi-column caption="Mã phiếu" dataField="sid" dataType="string" [fixed]="true"></dxi-column>
      <dxi-column cssClass="text-center" caption="Mã CTV" dataField="partnerCode" [fixed]="true"></dxi-column>
      <dxi-column caption="Tên CTV" dataField="partnerName"></dxi-column>
      <dxi-column caption="Hình thức CK" dataField="discountPaymentTypeText"></dxi-column>
      <dxi-column caption="Tên khách hàng" dataField="patientName"></dxi-column>
      <dxi-column caption="Giá niêm yết" dataType="number" dataField="money" format=",##0.###"></dxi-column>
      <dxi-column caption="CK trực tiếp" dataField="chietKhauTT" format=",##0.###"></dxi-column>
      <dxi-column caption="CK sau" dataField="chietKhauSau" format=",##0.###"></dxi-column>
      <dxi-column caption="Giá thu" dataField="netMoney" format=",##0.###"></dxi-column>
      <dxi-column caption="Ngày tạo" dataField="createdDate" dataType="date" format="dd/MM/yy"></dxi-column>
      <dxi-column caption="NVLM" dataField="userTakeSpecimen"></dxi-column>
      <dxi-column caption="NVKD" dataField="nvkd"></dxi-column>
      <dxi-column type="buttons" [fixed]="true" fixedPosition="right" width="50px">
        <dxi-button
          hint="Chi tiết"
          [onClick]="actionDetailToPay"
          icon="info"
        ></dxi-button>
      </dxi-column>
      <div *dxTemplate="let item of 'cellIndexTemplate'">
        {{ item.rowIndex + 1 }}
      </div>
      <!--<div *dxTemplate="let item of 'cellSID'">
        {{item.data.createdDate | date:'ddMMyy'}}-{{item.data.specimenID}}
      </div>
      <div *dxTemplate="let item of 'cellPaymentTypeTemplate'">
        {{item.data.discountPaymentType === 2 ? 'CK sau' : 'CK trực tiếp'}}
      </div>-->

      <dxo-summary>
        <dxi-total-item
          column="specimenID"
          displayFormat="Số bản ghi: {0}"
          summaryType="count">
        </dxi-total-item>
        <dxi-total-item
          column="discountMoney"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
        <dxi-total-item
          column="money"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
        <dxi-total-item
          column="netMoney"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
        <dxi-total-item
          column="chietKhauTT"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
        <dxi-total-item
          column="chietKhauSau"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
      </dxo-summary>
    </dx-data-grid>
  </div>

  <div nz-col [nzSpan]="12">
    <div class="text-title">Đã thanh toán
      <button class="btn-right btn-green" (click)="exportPaidData()" nz-button nzType="primary" nzSize="small">
        <span class="fa fa-file-excel fa-fw"></span>
        Xuất dữ liệu
      </button>
    </div>

    <dx-data-grid #gridPaid
                  [height]="grid1Height"
                  [dataSource]="dataPaid"
                  (onExporting)="onGridPaidExporting($event)"
                  [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true" [showColumnLines]="true"
                  [showRowLines]="true"
                  [selectedRowKeys]="[]"
                  (onSelectionChanged)="onPaidSelectionChanged($event)"
    >
      <dxi-column [fixed]="true"
                  caption="STT"
                  [width]="55"
                  [allowFiltering]="false"
                  [allowSorting]="false"
                  cssClass="text-center"
                  dataField="stt"
      ></dxi-column>
      <dxo-filter-row [visible]="true" [applyFilter]="currentFilter"></dxo-filter-row>
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-selection mode="single"></dxo-selection>
      <dxi-column caption="Mã phiếu" dataField="sid" [fixed]="true" dataType="string"></dxi-column>
      <dxi-column cssClass="text-center" caption="Mã CTV" dataField="partnerCode" [fixed]="true"></dxi-column>
      <dxi-column caption="Tên CTV" dataField="partnerName"></dxi-column>
      <dxi-column caption="Tên khách hàng" dataField="patientName"></dxi-column>
      <dxi-column caption="Hình thức CK" dataField="discountPaymentTypeText"></dxi-column>
      <dxi-column caption="Số tiền" dataField="money" format=",##0.###"></dxi-column>
      <dxi-column caption="Người thu" dataField="userCashier.fullname"></dxi-column>
      <dxi-column caption="TG thanh toán" dataField="paymentTime" dataType="date" format="HH:mm dd/MM/yy"></dxi-column>
      <dxi-column caption="Ngày tạo" dataField="createdDate" dataType="date" format="dd/MM/yy"></dxi-column>
      <div *dxTemplate="let item of 'cellIndexTemplate'">
        {{ item.rowIndex + 1 }}
      </div>
      <div *dxTemplate="let item of 'cellSID'">
        {{ item.data.createdDate | date:'ddMMyy' }}-{{ item.data.specimenID }}
      </div>

      <dxo-summary>
        <dxi-total-item
          column="specimenID"
          displayFormat="Số bản ghi: {0}"
          summaryType="count">
        </dxi-total-item>
        <dxi-total-item
          column="money"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
      </dxo-summary>
    </dx-data-grid>
  </div>
</div>


<div nz-row class="row2">
  <div nz-col [nzSpan]="12">
    <div nz-row style="margin:6px 0; margin-left: 5px;">
      <!--<button style="margin-right: 8px;" nz-button nzType="primary" [disabled]="totalPrices == 0" (click)="paidMoney()">
        Thanh toán
      </button>-->
      <button class="btn-right btn-green" nz-button nzType="primary" [disabled]="currentBill && !currentBill.specimenID"
              (click)="printPhieuThu()">
        <span class="fa fa-print fa-fw"></span>
        In phiếu
      </button>
      <button class="btn-right btn-green" nz-button nzType="primary" [disabled]="currentBill && !currentBill.specimenID"
              (click)="printPhieuThu(true)">
        <span class="fa fa-print fa-fw"></span>
        In phiếu (CK tổng)
      </button>
    </div>
    <dx-data-grid #gridDetailNeedPaid
                  [height]="grid2Height"
                  [dataSource]="detailToPay" [showBorders]="true" [columnAutoWidth]="true"
                  [rowAlternationEnabled]="true" [showColumnLines]="true" [showRowLines]="true"
    >
      <dxi-column [fixed]="true"
                  caption="STT"
                  [width]="55"
                  [allowFiltering]="false"
                  [allowSorting]="false"
                  cssClass="text-center"
                  cellTemplate="cellIndexTemplate"
      ></dxi-column>
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxi-column caption="Dịch vụ" dataField="orderTypeName" dataType="string"></dxi-column>
      <dxi-column caption="Giá niêm yết" dataField="price" format=",##0.###"></dxi-column>
      <dxi-column caption="Chiết khấu" dataField="discountPrice" format=",##0.###"></dxi-column>
      <dxi-column caption="Giá thu về" dataField="netPrice" format=",##0.###"></dxi-column>
      <dxi-column caption="UserIn" dataField="userIn" dataType="string"></dxi-column>
      <dxi-column caption="TimeIn" dataField="timeIn" format="HH:mm dd/MM/yy" dataType="date"></dxi-column>
      <div *dxTemplate="let item of 'cellIndexTemplate'">
        {{ item.rowIndex + 1 }}
      </div>
      <div *dxTemplate="let item of 'cellCKTemplate'">
        {{ item.data.discountPaymentType === 1 ? 'CK trực tiếp' : 'CK sau' }}
      </div>
      <dxo-summary>
        <dxi-total-item
          column="orderTypeName"
          displayFormat="Số bản ghi: {0}"
          summaryType="count">
        </dxi-total-item>
        <dxi-total-item
          column="price"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
        <dxi-total-item
          column="discountPrice"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
        <dxi-total-item
          column="netPrice"
          displayFormat="{0}"
          valueFormat=",##0.###"
          summaryType="sum">
        </dxi-total-item>
      </dxo-summary>
    </dx-data-grid>
  </div>

  <div nz-col [nzSpan]="12">
    <div nz-row style="margin:6px 0; margin-left: 5px;">
      <!--<button style="margin-right: 8px;" nz-button nzType="primary" [disabled]="totalPrices == 0" (click)="paidMoney()">
        Thanh toán
      </button>-->
      <button class="btn-right btn-green" nz-button nzType="primary" [disabled]="!currentBillPaid.specimenID"
              (click)="printPhieuThanhToan(true)">
        <span class="fa fa-print fa-fw"></span>
        In có CK (chi tiết)
      </button>
      <button class="btn-right btn-green" nz-button nzType="primary" [disabled]="!currentBillPaid.specimenID"
              (click)="printPhieuThanhToan(false, true)">
        <span class="fa fa-print fa-fw"></span>
        In có CK (tổng)
      </button>
      <button class="btn-right btn-green" nz-button nzType="primary" [disabled]="!currentBillPaid.specimenID"
              (click)="printPhieuThanhToan(false)">
        <span class="fa fa-print fa-fw"></span>
        In không CK
      </button>
      <button class="btn-right btn-orange" nz-button nzType="primary"
              [disabled]="!selectedDetailPaidIds.length || !currentBillPaid.specimenID"
              (click)="openExpenseModal()">
        <span class="fa fa-file-invoice-dollar fa-fw"></span>
        Tạo phiếu chi
      </button>
    </div>
    <dx-data-grid #gridDetailPaid
                  [height]="grid2Height"
                  [dataSource]="detailPaid"
                  [showBorders]="true" [columnAutoWidth]="true"
                  [rowAlternationEnabled]="true" [showColumnLines]="true" [showRowLines]="true"
                  (onCellPrepared)="onDetailPaidCellPrepared($event)"
                  (onSelectionChanged)="onDetailPaidSelectionChanged($event)"
    >
      <dxo-selection
        [selectAllMode]="'allPages'"
        [showCheckBoxesMode]="'always'"
        mode="multiple"
      ></dxo-selection>
      <dxi-column [fixed]="true"
                  caption="STT"
                  [width]="55"
                  [allowFiltering]="false"
                  [allowSorting]="false"
                  cssClass="text-center"
                  cellTemplate="cellIndexTemplate"
      ></dxi-column>
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-header-filter [visible]="true"></dxo-header-filter>

      <dxi-column caption="Dịch vụ" dataField="orderTypeName"
                  dataType="string" cellTemplate="cellServiceName">
      </dxi-column>
      <dxi-column caption="Giá niêm yết" dataField="price" format=",##0.###"></dxi-column>
      <dxi-column caption="UserIn" dataField="userIn" dataType="string"></dxi-column>
      <dxi-column caption="TimeIn" dataField="timeIn" format="HH:mm dd/MM/yy" dataType="date"></dxi-column>

      <!-- Template tên dịch vụ: hiện icon nếu đã xuất toán -->
      <div *dxTemplate="let item of 'cellServiceName'">
        <span [class.expense-paid]="item.data.isExpensePaid">
          {{ item.data.orderTypeName }}
          <i *ngIf="item.data.isExpensePaid"
             class="fa fa-check-circle"
             style="color: #52c41a; margin-left: 4px;"
             title="Đã tạo phiếu chi">
          </i>
        </span>
      </div>

      <div *dxTemplate="let item of 'cellIndexTemplate'">
        {{ item.rowIndex + 1 }}
      </div>

      <dxo-summary [calculateCustomSummary]="calculateExpensePaidSummary">
        <dxi-total-item column="orderTypeName"
                        displayFormat="Số bản ghi: {0}"
                        summaryType="count">
        </dxi-total-item>

        <!-- Bỏ dòng sum mặc định, thay bằng 2 custom -->
        <dxi-total-item
          summaryType="custom"
          name="expenseRemaining"
          displayFormat="Sau xuất toán: {0}"
          valueFormat=",##0.###"
          showInColumn="price">
        </dxi-total-item>
        <dxi-total-item
          summaryType="custom"
          name="expensePaidTotal"
          displayFormat="Đã xuất toán: {0}"
          valueFormat=",##0.###"
          showInColumn="price">
        </dxi-total-item>
      </dxo-summary>
    </dx-data-grid>
  </div>
</div>

<!-- Modal tạo phiếu chi -->
<nz-modal
  [(nzVisible)]="isVisibleExpenseModal"
  nzTitle="Tạo phiếu chi (xuất toán)"
  (nzOnCancel)="isVisibleExpenseModal = false"
  (nzOnOk)="createExpense()"
  [nzOkLoading]="loadingCreateExpense"
  nzOkText="Tạo phiếu chi"
  nzCancelText="Hủy"
  [nzOkDisabled]="!expenseReason.trim()"
>
  <ng-container *nzModalContent>
    <p>Đã chọn <strong>{{ selectedDetailPaidIds.length }}</strong> dịch vụ</p>
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzRequired>Lý do</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <textarea
          nz-input
          [(ngModel)]="expenseReason"
          [nzAutosize]="{ minRows: 3, maxRows: 5 }"
          placeholder="Nhập lý do tạo phiếu chi..."
        ></textarea>
      </nz-form-control>
    </nz-form-item>
  </ng-container>
</nz-modal>

